












































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
@Component({
  components: {
    PicPreview,
  },
})
export default class IdrSheJiqi extends Vue {
  @Prop()
  private current: any;
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  private mianOptions1: any = [
    "红黄隐隐，明润含蓄",
    "面色红",
    "面色白",
    "面色姜黄",
    "面色黄",
  ];
  private mianOptions2: any = ["有", "无"];
  private mianOptions3: any = ["有光泽", "少量光泽", "无光泽"];
  private mianOptions4: any = ["唇色青紫", "唇色暗红", "唇色淡", "唇色红"];
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
  private selectChange(e, index) {
    if (index === 0) {
      this.current['专家标注报告']["面色唇色参数"][3][0] = e;
    } else if (index === 4) {
      this.current['专家标注报告']["面色唇色参数"][3][6] = e;
    }
  }
}
